// function loadProductDetails(productId) {
//     console.log('Loading product details for product ID: ' + productId);
//     $.ajax({
//         url: jaskInventory.ajaxUrl,
//         method: 'POST',
//         data: {
//             action: 'jask_inventory_get_product_details',
//             security: jaskInventory.nonce,
//             product_id: productId
//         },
//         success: function(response){
//             if(response.success){
//                 console.log('Product details loaded successfully.');
//             } else {
//                 console.log('Error loading product details: ' + response.data);
//             }
//         },
//         error: function(){
//             console.log('An unexpected error occurred while loading product details.');
//         }
//     });
// }

function refreshProductVisuals() {
    console.log('Refreshing product visuals.');
    var item_id = $('.edit-item-form').data('item-id');
    $.ajax({
        url: jaskInventory.ajaxUrl,
        method: 'POST',
        data: {
            action: 'jask_inventory_get_product_visuals',
            security: jaskInventory.nonce,
            item_id: item_id
        },
        success: function(response){
            if(response.success){
                console.log('Product visuals refreshed successfully.');
                $('.visuals-grid').html(response.data.html);
            }
        },
        error: function(){
            console.log('An unexpected error occurred while refreshing product visuals.');
        }
    });
}

function remove_hash_from_url() {
    var uri = window.location.toString();

    if (uri.indexOf("#") > 0) {
        var clean_uri = uri.substring(0, 
                        uri.indexOf("#"));

        window.history.replaceState({}, 
                document.title, clean_uri);
    }
}

function loadVariationDetails(variationId) {
    $('a[href^="#edit-variation"]').parents('tr').removeClass('active');
    $('a[href="#edit-variation[' + variationId + ']"]').parents('tr').addClass('active');
    console.log('Loading variation details for variation ID: ' + variationId);
    $.ajax({
        url: jaskInventory.ajaxUrl,
        method: 'POST',
        data: {
            action: 'jask_inventory_get_variation_details',
            security: jaskInventory.nonce,
            variation_id: variationId
        },
        success: function(response){
            if(response.success){

                $('.update-variation-form .slide-down-element-content').html(response.data.html);

                // $('.update-variation-form .variation-name').remove();
                // $('.update-variation-form h4').after('<span class="variation-name">' + response.data.variation_name + '</span>');
                // $('.update-variation-form ul.form-inputs').empty();
                // $('#update-variation-id').val(variationId);
                // $.each(response.data.attributes, function(name, object){
                //     $('.update-variation-form ul.form-inputs').append('<li>' + object.html + '</li>');
                    
                // });
                // $('.update-variation-form ul.form-inputs').append('<li><label for="variation-sku">SKU</label><input type="text" id="variation-sku" name="variation-sku" value="' + response.data.sku + '"></li>');
                // $('.update-variation-form ul.form-inputs').append('<li><label for="variation-qty">Stock</label><input type="number" id="variation-qty" name="variation-qty" value="' + response.data.stock_qty + '"></li>');
            } else {
                console.log('Error loading variation details: ' + response.data);
            }
        },
        error: function(){
            console.log('An unexpected error occurred while loading variation details.');
        }
    });
}

function createNewVariation(productId) {
    $('.new-variation-form ul.form-inputs input').val('');
    $.ajax({
        url: jaskInventory.ajaxUrl,
        method: 'POST',
        data: {
            action: 'jask_inventory_create_new_variation',
            security: jaskInventory.nonce,
            product_id: productId
        },
        success: function(response){
            if(response.success){

                $('.new-variation-form .slide-down-element-content').html(response.data.html);

                // $('.new-variation-form ul.form-inputs').empty();
                // $('#new-variation-product-id').val(productId);
                // $.each(response.data.attributes, function(name, object){
                //     $('.new-variation-form ul.form-inputs').append('<li>' + object.html + '</li>');
                    
                // });
                // $('.new-variation-form ul.form-inputs').append('<li><label for="variation-sku">Item #</label><input type="text" id="variation-sku" name="variation-sku" value="' + response.data.sku + '" placeholder="' + response.data.placeholder_sku + '"></li>');
                // $('.new-variation-form ul.form-inputs').append('<li><label for="variation-qty">Stock</label><input type="number" id="variation-qty" name="variation-qty" value="1"></li>');
            } else {
                console.log('Error creating new variation: ' + response.data);
            }
        },
        error: function(){
            console.log('An unexpected error occurred while creating new variation.');
        }
    });
}

function updateVariationTable(variationTableElement) {
    const productId = variationTableElement ? variationTableElement.dataset.productId : null;
    if (!productId) {
        console.log('Product ID not found for variation table update.');
        return;
    }
    $.ajax({
        url: jaskInventory.ajaxUrl,
        method: 'POST',
        data: {
            action: 'jask_inventory_get_variation_table',
            product_id: productId,
            security: jaskInventory.nonce
        },
        success: function(response){
            if(response.success){
                console.log('Variation table updated successfully for product ID: ' + productId);
                if (variationTableElement) {
                    variationTableElement.innerHTML = response.data.html;
                }
            } else {
                console.log('Error updating variation table for product ID ' + productId + ': ' + response.data);
            }
        },
        error: function(){
            console.log('An unexpected error occurred while updating variation table for product ID: ' + productId);
        }
    });
}

function updateProductStatus(productStatusElement) {
    const productId = productStatusElement ? productStatusElement.dataset.productId : null;
    if (!productId) {
        console.log('Product ID not found for status update.');
        return;
    }
    $.ajax({
        url: jaskInventory.ajaxUrl,
        method: 'POST',
        data: {
            action: 'jask_inventory_get_product_status',
            product_id: productId,
            security: jaskInventory.nonce
        },
        success: function(response){
            if(response.success){
                console.log('Product status updated successfully.');
                const draft = response.data.draft ? 'draft' : '';
                if (draft) {
                    var status = 'draft';
                } else {
                    var status = response.data.available ? 'available' : 'unavailable';
                }
                if (productStatusElement) {
                    productStatusElement.classList.remove('available', 'unavailable', 'draft');
                    productStatusElement.classList.add(status);
                    productStatusElement.textContent = 'Status: ' + (response.data.draft ? 'Draft' : (response.data.available ? 'Available' : 'Unavailable'));
                }
            } else {
                console.log('Error updating product status: ' + response.data);
            }
        },
        error: function(){
            console.log('An unexpected error occurred while updating product status.');
        }
    });
}

function updateHistoryLog(historyLogElement) {
    const productId = historyLogElement ? historyLogElement.dataset.productId : null;
    if (!productId) {
        console.log('Product ID not found for history log update.');
    }
    $.ajax({
        url: jaskInventory.ajaxUrl,
        method: 'POST',
        data: {
            action: 'jask_inventory_get_product_history_log',
            product_id: productId,
            security: jaskInventory.nonce
        },
        success: function(response){
            if(response.success){
                console.log('Product history log updated successfully.');
                if (historyLogElement) {
                    historyLogElement.innerHTML = response.data.html;
                }
            } else {
                console.log('Error updating product history log: ' + response.data);
            }
        },
        error: function(){
            console.log('An unexpected error occurred while updating product history log.');
        }
    });
}

function updateProductActions(productActionsElement) {
    const productId = productActionsElement ? productActionsElement.dataset.productId : null;
    if (!productId) {
        console.log('Product ID not found for actions update.');
        return;
    }
    $.ajax({
        url: jaskInventory.ajaxUrl,
        method: 'POST',
        data: {
            action: 'jask_inventory_get_product_actions',
            product_id: productId,
            security: jaskInventory.nonce
        },
        success: function(response){
            if(response.success){
                console.log('Product actions updated successfully.');
                if (productActionsElement) {
                    productActionsElement.innerHTML = response.data.html;
                }
            } else {
                console.log('Error updating product actions: ' + response.data);
            }
        },
        error: function(){
            console.log('An unexpected error occurred while updating product actions.');
        }
    });
}

function beginCameraUpload() {
    var initialHash = window.location.hash;
    const productIdMatch = initialHash.match(/upload-visual\[(\d+)\]/);
    const productId = productIdMatch[1];

    //ask for camera permission and if granted, open the upload visual modal
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({ video: true })
        .then(function(stream) {
            $.ajax({
                url: jaskInventory.ajaxUrl,
                method: 'POST',
                data: {
                    action: 'jask_inventory_get_camera_modal_content',
                    security: jaskInventory.nonce,
                    product_id: productId,
                    function: 'upload_product_photo'            
                },
                success: function(response){
                    if(response.success){
                        console.log('Camera modal content loaded successfully.');
                        //remove any existing camera modals
                        $('#upload-visual-modal').remove();
                        $('#page').append(response.data.html);

                        $('#upload-visual-modal .camera-controls').removeClass('captured');
                        $('#capture-canvas').hide();
                        $('#camera-stream').show().css('opacity', '1');
                        $('#upload-visual-modal').addClass('active');
                        //add the video stream to the video element in the modal
                        var video = document.getElementById('camera-stream');
                        if ("srcObject" in video) {
                            video.srcObject = stream;
                        } else {
                            // For older browsers
                            video.src = window.URL.createObjectURL(stream);
                        }
                        video.play();

                        window.setTimeout(function(){
                            $('#upload-visual-modal').addClass('active');
                        }, 10);
                    } else {
                        console.log('Error loading camera modal content: ' + response.data);
                    }
                },
                error: function(){
                    console.log('An unexpected error occurred while loading camera modal content.');
                }
            });
        })
        .catch(function(err) {
            console.log('Camera permission denied: ' + err);
            alert('Camera permission is required to upload a visual. Please allow camera access and try again.');
        }); 
        
    } else {
        alert('Camera access is not supported in this browser. Please use a compatible browser to upload a visual.');
    }
}

function capturePhoto() {

    //create a new promise to capture the photo from the video stream and convert it to a file object, then set that file object to the file input in the upload visual form
    new Promise(function(resolve, reject) {
        var video = document.getElementById('camera-stream');
        var canvas = document.getElementById('capture-canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        var context = canvas.getContext('2d');
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(function(blob) {
            if (blob) {
                var file = new File([blob], 'captured_photo.png', { type: 'image/png' });
                resolve(file);
            } else {
                reject(new Error('Failed to capture photo.'));
            }
        }, 'image/png');
    }).then(function(file) {
        var dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        var photoInput = document.getElementById('photo-file-input');
        photoInput.files = dataTransfer.files;
        $('#upload-photo-button').data('photo', file);
        //update the modal to show the captured photo and show the confirm and retake buttons
        var reader = new FileReader();
        reader.onload = function(e) {
            $('#capture-canvas').attr('src', e.target.result).show();
            $('#camera-stream').css('opacity', '0');
            $('#upload-visual-modal .camera-controls').addClass('captured');
        }
        reader.readAsDataURL(file);
    }).catch(function(err) {
        console.log('Error capturing photo: ' + err);
        alert('An error occurred while capturing the photo. Please try again.');
    });
    //end the camera stream
    endCameraUpload();
}

function endCameraUpload() {
    //stop the camera stream and close the modal
    var video = document.getElementById('camera-stream');
    if (!video) {
        return;
    }
    var stream = video.srcObject;
    if (stream) {
        var tracks = stream.getTracks();
        tracks.forEach(function(track) {
            track.stop();
        });
    }
    video.srcObject = null;
}

function restartCameraStream() {
    var video = document.getElementById('camera-stream');
    if (!video) {
        return;
    }
    navigator.mediaDevices.getUserMedia({ video: true })
    .then(function(stream) {
        if ("srcObject" in video) {
            video.srcObject = stream;
        } else {
            // For older browsers
            video.src = window.URL.createObjectURL(stream);
        }
        video.play();
    }).catch(function(err) {
        console.log('Error restarting camera stream: ' + err);
        alert('An error occurred while restarting the camera stream. Please allow camera access and try again.');
    });
}

function switchCamera() {
    var video = document.getElementById('camera-stream');
    if (!video) {
        return;
    }
    var stream = video.srcObject;
    if (stream) {
        var tracks = stream.getTracks();
        tracks.forEach(function(track) {
            track.stop();
        });
    }

    //get the current camera facing mode
    var currentFacingMode = video.dataset.facingMode || 'user';
    var newFacingMode = currentFacingMode === 'environment' ? 'user' : 'environment';
    navigator.mediaDevices.getUserMedia({ video: { facingMode: newFacingMode } })
    .then(function(newStream) {
        video.srcObject = newStream;
        video.dataset.facingMode = newFacingMode;
    })
    .catch(function(err) {
        console.log('Error switching camera: ' + err);
        alert('An error occurred while switching the camera. Please try again.');
    });
}

function handleFileUploadClick() {

    var video = document.getElementById('camera-stream');
    if (video && video.srcObject) {
        var tracks = video.srcObject.getTracks();
        tracks.forEach(function(track) {
            track.stop();
        });
        video.srcObject = null;
    }

    $('#local-photo-file-input').trigger('click');

    $('#local-photo-file-input').off('change').on('change', function(){
        var file = this.files[0];
        if (file) {

            //check the server max upload file size and if the file exceeds that, show an error message
            var maxUploadSize = jaskInventory.maxUploadSize || 0;
            if (maxUploadSize > 0 && file.size > maxUploadSize) {
                alert('The selected file exceeds the maximum upload size of ' + (maxUploadSize / 1024 / 1024).toFixed(2) + ' MB. Please select a smaller file.');
                return;
            }

            //check the file type and if it's an image, set it to the file input in the upload visual form
            if (file.type.startsWith('image/')) {
                $('#photo-file-input')[0].files[0] = file;
                var dataTransfer = new DataTransfer();
                dataTransfer.items.add(file);
                var photoInput = document.getElementById('photo-file-input');
                photoInput.files = dataTransfer.files;
                $('#upload-photo-button').data('photo', file);
                //update the modal to show the captured photo and show the confirm and retake buttons
                var reader = new FileReader();
                reader.onload = function(e) {
                    //resize the image to the canvas size before showing it in the modal
                    var img = new Image();
                    img.onload = function() {
                        var canvas = document.getElementById('capture-canvas');
                        var context = canvas.getContext('2d');
                        canvas.width = img.width;
                        canvas.height = img.height;
                        context.drawImage(img, 0, 0, canvas.width, canvas.height);
                        $('#capture-canvas').attr('src', canvas.toDataURL('image/png')).show();
                        $('#camera-stream').css('opacity', '0');
                        $('#upload-visual-modal .camera-controls').addClass('captured');
                    }
                    img.src = e.target.result;
                }
                reader.readAsDataURL(file);
            } else {
                alert('Please select a valid image file.');
            }
        }
    });
    // // Stop/pause the camera stream before triggering file input
    // var video = document.getElementById('camera-stream');
    // if (video && video.srcObject) {
    //     var tracks = video.srcObject.getTracks();
    //     tracks.forEach(function(track) {
    //         track.stop();
    //     });
    //     video.srcObject = null;
    // }
    // // Now trigger the file input
    // $('#photo-file-input').trigger('click');
    // console.log('Triggered file input click for photo upload.');
    // // Add a change event listener to handle the file selection
    // $('#photo-file-input').off('change').on('change', function(){
    //     var file = this.files[0];
    //     if (file) {
    //         $('#upload-photo-button').data('photo', file);
    //         var reader = new FileReader();
    //         reader.onload = function(e) {
    //             $('#capture-canvas').attr('src', e.target.result).show();
    //             $('#camera-stream').css('opacity', '0');
    //             $('#upload-visual-modal .camera-controls').addClass('captured');
    //         }
    //         reader.readAsDataURL(file);
    //     }
    // });
}

function launchProductModal() {
    var initialHash = window.location.hash;
    const productIdMatch = initialHash.match(/open-modal-product\[(\d+)\]/);
    $('.modal-product-overlay').addClass('active');
    //get the product ID from the hash if needed between []
    if (productIdMatch) {
        const productId = productIdMatch[1];

        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: {
                action: 'jask_inventory_get_product_details',
                wardrobe_item_id: productId,
                security: jaskInventory.nonce
            },
            success: function(response){
                if(response.success){
                    console.log('Product details loaded successfully.');
                    //remove any existing product modals
                    $('.modal-product-overlay').remove();
                    $('#page').append(response.data.html);
                    window.setTimeout(function(){
                        $('.modal-product-overlay').addClass('active');
                    }, 10);
                } else {
                    console.log('Error loading product details: ' + response.data);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while loading product details.');
            }
        });

        console.log('Open modal for product ID: ' + productId);
    }
}

function launchVariationMerge() {
    var initialHash = window.location.hash;
    const variationData = initialHash.match(/merge-variation\[(\d+)::(\d+)\]/);
    if (variationData) {
        const variationId = variationData[1];
        const mergeVariationId = variationData[2];

        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: {
                action: 'jask_inventory_get_variation_merge_details',
                security: jaskInventory.nonce,
                variation_id: variationId,
                merge_variation_id: mergeVariationId
            },
            success: function(response){
                if(response.success){
                    if (response.data.error && response.data.error.length > 0) {
                        console.log('Error loading variation merge details: ' + response.data.error);
                        return;
                    }
                    console.log('Variation merge details loaded successfully.');
                    //remove any existing variation merge modals
                    $('.modal-variation-merge-overlay').remove();
                    $('#page').append(response.data.html);
                    window.setTimeout(function(){
                        $('.modal-variation-merge-overlay').addClass('active');
                        $('.checkbox-btn input[name="sku"][value="existing"]').prop('checked', true);
                        var target = $('#keep-existing-sku-button');
                        merge_click_actions(target);
                        $('.checkbox-btn input[name="qty"][value="add_current"]').prop('checked', true);
                        $('.checkbox-btn input[name="qty"][value="add_existing"]').prop('checked', true);
                        var target = $('#add_existing-qty-button');
                        merge_click_actions(target);
                    }, 10);
                } else {
                    console.log('Error loading variation merge details: ' + response.data);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while loading variation merge details.');
            }
        });
    }
}

function stopVariationMerge() {
    console.log('Stopping variation merge and closing modal.');
    $('.modal-variation-merge-overlay').removeClass('active');
}

function merge_click_actions(target) {
    //find all other inputs with the same name and check them, uncheck all other inputs with the same name
    if (target.parent().find('input').val() === 'ignore_current' || target.parent().find('input').val() === 'ignore_existing') {
        $('input:not([value="ignore_current"]):not([value="ignore_existing"]):not([name="sku"])').prop('checked', false);
        $('input[value="ignore_current"], input[value="ignore_existing"]').prop('checked', true);
        $('#current-variation-qty, #existing-variation-qty').addClass('ignored');
        $('#current-variation-qty').text($('#current-variation-qty').attr('original-value'));
        $('#existing-variation-qty').text($('#existing-variation-qty').attr('original-value'));
    } else if (target.parent().find('input').val() === 'add_current' || target.parent().find('input').val() === 'add_existing') {
        if (!$('#current-variation-qty').attr('original-value')) {
            $('#current-variation-qty').attr('original-value', $('#current-variation-qty').text());
        }
        if (!$('#existing-variation-qty').attr('original-value')) {
            $('#existing-variation-qty').attr('original-value', $('#existing-variation-qty').text());
        }
        $('#current-variation-qty').text(parseInt($('#current-variation-qty').attr('original-value')) + parseInt($('#existing-variation-qty').attr('original-value')));
        $('#existing-variation-qty').text(parseInt($('#existing-variation-qty').attr('original-value')) + parseInt($('#current-variation-qty').attr('original-value')));
        $('input:not([value="add_current"]):not([value="add_existing"]):not([name="sku"])').prop('checked', false);
        $('input[value="add_current"], input[value="add_existing"]').prop('checked', true);
        $('#current-variation-qty, #existing-variation-qty').removeClass('ignored');
    } else if (target.parent().find('input').attr('name') === 'sku') {
        $('input[name="' + target.parent().find('input').attr('name') + '"]').prop('checked', false);
        if (target.parent().find('input').data('side') === 'current') {
            $('#existing-variation-sku').addClass('ignored');
            $('#current-variation-sku').removeClass('ignored');
        } else {
            $('#current-variation-sku').addClass('ignored');
            $('#existing-variation-sku').removeClass('ignored');
        }
    } else {
        $('input[name="' + target.parent().find('input').attr('name') + '"]').prop('checked', false);
        $('#current-variation-qty, #existing-variation-qty').removeClass('ignored');
        $('#current-variation-qty').text($('#current-variation-qty').attr('original-value'));
        $('#existing-variation-qty').text($('#existing-variation-qty').attr('original-value'));
        //check the data-side of the input and add the ignored class to the opposite qty
        if (target.parent().find('input').data('side') === 'current' && target.parent().find('input').val() === 'keep_current') {
            $('#existing-variation-qty').addClass('ignored');
        } else if (target.parent().find('input').data('side') === 'existing' && target.parent().find('input').val() === 'keep_existing') {
            $('#current-variation-qty').addClass('ignored');
        }
    }
    target.parent().find('input').prop('checked', true);
}

jQuery(document).ready(function($) {

    //implement dirty input warning for any form with the class .dirty-warning, excluding inputs with the class .no-dirty-warning
    $('.dirty-warning').each(function(){
        var form = this;
        $(form).find('input, select, textarea').not('.no-dirty-warning').each(function(){ 
            $(this).data('initial-value', $(this).val());
            $(this).on('change input', function(){
                var dirty = false;
                $(form).find('input, select, textarea').not('.no-dirty-warning').each(function(){
                    if ($(this).val() != $(this).data('initial-value')) {
                        dirty = true;
                        return false;
                    }
                });
                if (dirty) {
                    $(form).addClass('dirty');
                    //find the submit button in the form and add a warning class to it
                    $('.track-unsaved').addClass('unsaved');
                } else {
                    $(form).removeClass('dirty');
                }
            });
        });
    });

    //add an unload warning if there are any forms with the class .dirty-warning that have been changed
    $(window).on('beforeunload', function(){
        if ($('.dirty-warning.dirty').length > 0) {
            return 'You have unsaved changes. Are you sure you want to leave?';
        }
    });

    $('body').on('click', '.merge-comparison .actions a', function(e){
        merge_click_actions($(this));
        e.preventDefault();
    });

    const productStatusElements = document.getElementsByClassName('product-status');
    const productHistoryLogElements = document.getElementsByClassName('history-log');
    const productActionsElements = document.getElementsByClassName('page-actions');
    const productVariationsElements = document.getElementsByClassName('variation-table');

    Array.from(productStatusElements).forEach(function(element) {
        element.addEventListener('click', function() {
            updateProductStatus(this);
        });
    });


    //convert any select[multiple] to a select2 multi-select
    $('select[multiple]').each(function(){
        $(this).select2({
            width: '100%',
            placeholder: $(this).data('placeholder') || 'Select options',
            allowClear: true
        });
    });

    if (window.matchMedia) {
        const query = window.matchMedia('prefers-color-scheme: dark');
    }

    const isDarkMode = () => {
        return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    }

    const runColorMode = (fn) => {
        if (!window.matchMedia) {
            return;
        }
        
        const query = window.matchMedia('(prefers-color-scheme: dark)');

        fn(query.matches);

        query.addEventListener('change', (event) => fn(event.matches));
    }

    runColorMode((isDarkMode) => {
        if (isDarkMode) {
            $('html').attr('data-theme', 'dark');
            localStorage.setItem("theme", "dark");
        } else {
            $('html').attr('data-theme', 'light');
            localStorage.setItem("theme", "light");
        }
    });

    // get theme on page load
    // var theme = localStorage.getItem("theme");
    // if (theme) {
    //     $('html').attr('data-theme', theme);
    // } else {
    //     //detect system preference
    //     if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    //         $('html').attr('data-theme', 'dark');
    //         localStorage.setItem("theme", "dark");
    //     } else {
    //         $('html').attr('data-theme', 'light');
    //         localStorage.setItem("theme", "light");
    //     }
    // }

    // toggle theme on button click
    $('body').on('click', '[data-theme-toggle]', function(){
        var currentTheme = $('html').attr('data-theme');
        var newTheme = (currentTheme === 'light') ? 'dark' : 'light';
        $('html').attr('data-theme', newTheme);
        localStorage.setItem("theme", newTheme);
    });

    // $('.sidebar').on('mouseenter', function(){
    //     $('body').addClass('sidebar-expanded');
    // } ).on('mouseleave', function(){
    //     $('body').removeClass('sidebar-expanded');
    // });

    function updateInventoryAvailability(){
        // Function to update inventory availability - can be expanded as needed
        if ($('.inventory-available .items-list').length) {
            $('.inventory-available .items-list ul').empty();
            var manage = $('#inventory-manage').val() ?? 0;
            var data = {
                action: 'get_available_inventory',
                security: jaskInventory.nonce,
            }

            if (manage) {
                console.log('Loading inventory in manage mode.');
                $('.inventory-available').addClass('manage');
                data.manageNonce = jaskInventory.manageNonce;
            }

            console.log(data);

            $.ajax({
                url: jaskInventory.ajaxUrl,
                method: 'POST',
                data: data,
                success: function(invResponse){
                    if(invResponse.success){
                        console.log('Inventory form loaded successfully.');
                        if (invResponse.data.items !== null) {
                            invResponse.data.items.forEach(function(item){
                                $('.inventory-available .items-list ul').append(item);
                            });
                        }
                    } else {
                        console.log('Error loading inventory form: ' + invResponse.data);
                    }
                },
                error: function(){
                    console.log('An unexpected error occurred while loading inventory form.');
                }
            });

        }
    }

    function updateInventorySelected(){
        if ($('.inventory-selected .items-list').length) {
            $('.inventory-selected .items-list ul').empty();
            $.ajax({
                url: jaskInventory.ajaxUrl,
                method: 'POST',
                data: {
                    action: 'jask_inventory_get_active_reservation',
                    security: jaskInventory.nonce
                },
                success: function(reservationResponse){
                    if(reservationResponse.success){
                        $('.inventory-selected .items-list ul').append('<input type="hidden" id="reservation_id" value="' + reservationResponse.data.reservation_id + '">');
                        console.log('Active reservation loaded successfully.');
                        if (reservationResponse.data.reservation_items !== null) {
                            reservationResponse.data.reservation_items.forEach(function(item){
                                $('.inventory-selected .items-list ul').append(item);
                            });
                        }
                    } else {
                        console.log('Error loading active reservation: ' + reservationResponse.data);
                    }
                },
                error: function(){
                    console.log('An unexpected error occurred while loading active reservation.');
                }
            });
        }
    }

    function updateInventoryRequested(){
        if ($('.inventory-requested .items-list').length) {
            $('.inventory-requested .items-list ul').empty();
            var reservationId = $('#inventory-request-id').val() ?? 0;
            $.ajax({
                url: jaskInventory.ajaxUrl,
                method: 'POST',
                data: {
                    action: 'jask_inventory_get_requested_reservation_items',
                    security: jaskInventory.nonce,
                    reservation_id: reservationId
                },
                success: function(requestedResponse){
                    if(requestedResponse.success){
                        // console.log(requestedResponse);
                        if (requestedResponse.data.reservation_items !== null) {
                            requestedResponse.data.reservation_items.forEach(function(item){
                                $('.inventory-requested .items-list ul').append(item);
                            });
                        }
                    } else {
                        console.log('Error loading requested reservation items: ' + requestedResponse.data);
                    }
                },
                error: function(){
                    console.log('An unexpected error occurred while loading requested reservation items.');
                }
            });
        }
    }

    updateInventoryAvailability();
    updateInventorySelected();
    updateInventoryRequested();

    $('body').on('blur', '.wardrobe-item-reservation-form .qty input', function(){
        var max_qty = parseInt($(this).attr('max'));
        $(this).removeClass('input-error');
        $('.add-to-cart-button').prop('disabled', false);
        if (parseInt($(this).val()) > max_qty) {
            $(this).addClass('input-error');
            $('.add-to-cart-button').prop('disabled', true);
        }
    });

    $('body').on('change', '.attribute-values', function(){
        var self = this;
        var this_attr = $(this).attr('name');
        var last_attr = $(self).parents('.attributes').find('.attribute.active').last();
        console.log('last: ', last_attr);
        var selected_values = [];
        $('select[name="' + this_attr + '"] option:selected').each(function(){
            selected_values.push($(this).val());
        });
        console.log('Filtering inventory for attribute: ' + this_attr + ' with values: ' + selected_values.join(','));

        //if we are chaning Size, reset everything
        if (this_attr === 'attribute[Size]') {
            $(self).parents('.attributes').find('.attribute').not($(this).parents('.attribute')).removeClass('active');
            //reset the attribute selects
            $(self).parents('.attributes').find('.attribute').not($(this).parents('.attribute')).find('select').each(function(){
                $(this).val(null);
            });
            //hide quantity selector
            $(self).parents('.input-group').find('.qty').removeClass('active');
            //reset the qty to 1
            $(self).parents('.input-group').find('.qty input').val(1);
            console.log('Size changed, resetting other attributes and quantity selector.');
        }
        $(self).parents('.input-group').find('.qty input').val(1); //reset qty to 1 on any attribute change
        var form = $(this).closest('form');
        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: 'post_form=' + encodeURIComponent(form.serialize()) + '&action=get_available_selected_inventory&security=' + jaskInventory.nonce + '&attribute_name=' + this_attr + '&attribute_values=' + encodeURIComponent(selected_values.join(',')),
            success: function(filterResponse){
                console.log(filterResponse);
                if(filterResponse.success){
                    for(var key in filterResponse.data.possible_values){
                        //update the thumbnail if provided
                        if (filterResponse.data.thumbnail) {
                            console.log('Updating thumbnail for attribute: ' + key);
                            $('#popover-item-' + filterResponse.data.wardrobe_item_id + ' .wardrobe-item-detail-image').html(filterResponse.data.thumbnail);
                        }
                        console.log(last_attr.find('select[name="attribute[' + key + ']"]'));
                        if (key == 'Size' || (last_attr.find('select[name="attribute[' + key + ']"]').length > 0) && $(self).parents('.attribute').is(last_attr)) {
                            continue; //skip size for now
                        } else {
                            console.log('Filtering options for attribute: ' + key);
                        }
                        //disable all options first
                        $('select[name="attribute[' + key + ']"] option').prop('disabled', true);
                        //enable only possible values
                        filterResponse.data.possible_values[key].forEach(function(value){
                            $('select[name="attribute[' + key + ']"] option[value="' + value + '"]').prop('disabled', false);
                        });
                        //re-enable the first option (placeholder)
                        $('select[name="attribute[' + key + ']"] option').first().prop('disabled', false);
                    }
                    if ($(self).parents('.attribute').next('.attribute').length === 0) {
                        //show quantity selector or final action
                        $(self).parents('.input-group').find('.qty').addClass('active');
                        $(self).parents('.input-group').find('.qty input').attr('max', filterResponse.data.max_quantity);
                        $(self).parents('.input-group').find('.qty .stock-max .max-value').text(filterResponse.data.max_quantity);
                        console.log('All attributes selected, showing quantity selector.');
                    } else {
                        $(self).parents('.attribute').next('.attribute').addClass('active');
                    }
                } else {
                    console.log('Error filtering inventory: ' + filterResponse.data);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while filtering inventory.');
            }
        });

    });
    
    $('body').on('click', '.wardrobe-item-reservation-form .add-to-cart-button', function(e){
        e.preventDefault();
        var form = $(this).closest('form');
        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: form.serialize(),
            success: function(reservationResponse){
                if(reservationResponse.success){
                    console.log($('#popover-item-' + reservationResponse.data.data.wardrobe_item_id + ' .wardrobe-item-reservation-form #quantity'));
                    $('#popover-item-' + reservationResponse.data.data.wardrobe_item_id + ' .wardrobe-item-reservation-form #quantity').attr('max', reservationResponse.data.updated_stock);
                    $('#popover-item-' + reservationResponse.data.data.wardrobe_item_id + ' .wardrobe-item-reservation-form .stock-max .max-value').text(reservationResponse.data.updated_stock);
                    //update available inventory list (re-run the ajax to get available inventory)
                    updateInventorySelected();
                    $('#popover-item-' + reservationResponse.data.data.wardrobe_item_id).parents('li').find('.wardrobe-item-card .quantity-total span').text(reservationResponse.data.wardrobe_item_stock.total);
                    $('#popover-item-' + reservationResponse.data.data.wardrobe_item_id).parents('li').find('.wardrobe-item-card .quantity-checked-out span').text(reservationResponse.data.wardrobe_item_stock.checked_out + ' (' + reservationResponse.data.wardrobe_item_stock.pending_check_out + ')');
                    $('#popover-item-' + reservationResponse.data.data.wardrobe_item_id).parents('li').find('.wardrobe-item-card .quantity-in-stock span').text(reservationResponse.data.wardrobe_item_stock.in_stock); 

                } else {
                    console.log('Error reserving item: ' + reservationResponse.data);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while reserving the item.');
            }
        });
    });

    $('body').on('click', '.remove-reservation-item-button', function(e){

        var confirmRemove = confirm('Are you sure you want to remove this item from your reservation?');
        if (!confirmRemove) {
            return;
        }

        e.preventDefault();
        var form = $(this).parents('.wardrobe-item-popover').find('.popover-content .wardrobe-item-detail .wardrobe-item-reservation-form');
        console.log('Removing reservation item...');
        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: form.serialize() + '&remove_reservation_item=1',
            success: function(reservationResponse){
                if(reservationResponse.success){
                    if (reservationResponse.data.deleted) {
                        //trigger the popover to close
                        $('#reservation-item-' + reservationResponse.data.reservation_item_id).find('.popover-content .actions .close-popover-button').trigger('click');
                        $('#reservation-item-' + reservationResponse.data.reservation_item_id).parents('li').slideUp(function(){
                            console.log($('#popover-item-' + reservationResponse.data.wardrobe_item_id));
                            $('#popover-item-' + reservationResponse.data.wardrobe_item_id).parents('li').find('.wardrobe-item-card .quantity-total span').text(reservationResponse.data.wardrobe_item_stock.total_quantity);
                            $('#popover-item-' + reservationResponse.data.wardrobe_item_id).parents('li').find('.wardrobe-item-card .quantity-checked-out span').text(reservationResponse.data.wardrobe_item_stock.checked_out + ' (' + reservationResponse.data.wardrobe_item_stock.pending_check_out + ')');
                            $('#popover-item-' + reservationResponse.data.wardrobe_item_id).parents('li').find('.wardrobe-item-card .quantity-in-stock span').text(reservationResponse.data.wardrobe_item_stock.in_stock); 
                            //trigger an update of '.attribute-values' selects to refresh availability
                            $('#popover-item-' + reservationResponse.data.wardrobe_item_id).find('.attribute-values').first().trigger('change');
                            $(this).remove();
                        });
                    }
                    console.log(reservationResponse);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while removing the reservation item.');
            }
        });
    });

    $('body').on('click', '.update-reservation-item-button', function(e){
        e.preventDefault();
        var form = $(this).closest('form');
        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: form.serialize(),
            success: function(reservationResponse){
                if(reservationResponse.success){
                    $('#reservation-item-' + reservationResponse.data.reservation_item_id).parents('li').find('.wardrobe-item-card .quantity-total span').text(reservationResponse.data.new_quantity);
                    $('#reservation-item-' + reservationResponse.data.reservation_item_id).find('.popover-content .actions .close-popover-button').trigger('click');
                    $('#popover-item-' + reservationResponse.data.wardrobe_item_id).parents('li').find('.wardrobe-item-card .quantity-total span').text(reservationResponse.data.wardrobe_item_stock.total_quantity);
                    $('#popover-item-' + reservationResponse.data.wardrobe_item_id).parents('li').find('.wardrobe-item-card .quantity-checked-out span').text(reservationResponse.data.wardrobe_item_stock.checked_out + ' (' + reservationResponse.data.wardrobe_item_stock.pending_check_out + ')');
                    $('#popover-item-' + reservationResponse.data.wardrobe_item_id).parents('li').find('.wardrobe-item-card .quantity-in-stock span').text(reservationResponse.data.wardrobe_item_stock.in_stock); 
                    $('#popover-item-' + reservationResponse.data.wardrobe_item_id).find('.attribute-values').first().trigger('change');
                }
            },
            error: function(){
                console.log('An unexpected error occurred while updating the reservation item.');
            }
        });
    });

    $('body').on('click', '.clear-selection', function(e){
        var confirmClear = confirm('Are you sure you want to clear your entire reservation selection? This action cannot be undone.');
        if (!confirmClear) {
            return;
        }
        var reservationId = $('#reservation_id').val();
        if (!reservationId) {
            console.log('No active reservation to clear.');
            return;
        }
        e.preventDefault();
        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: {
                action: 'jask_inventory_clear_active_reservation',
                reservation_id: reservationId,
                security: jaskInventory.nonce
            },
            success: function(clearResponse){
                if(clearResponse.success){
                    console.log('Active reservation cleared successfully.');
                    updateInventorySelected();
                    updateInventoryAvailability();
                } else {
                    console.log('Error clearing active reservation: ' + clearResponse.data);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while clearing active reservation.');
            }
        });
    });

    $('body').on('click', '.wardrobe-tabbed-details .tabs button', function(e){
        var tab_id = $(this).data('tab');
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
        var tab_container = $(this).closest('.wardrobe-tabbed-details');
        tab_container.find('.tabs').removeClass('expanded');
        tab_container.find('.active-tab').html($(this).text());
        tab_container.find('.tab-content').removeClass('active');
        $('#' + tab_id).addClass('active');
        e.preventDefault();
    });

    $('body').on('click', '.wardrobe-tabbed-details a.active-tab', function(e){
        e.preventDefault();
        $(this).parent().toggleClass('expanded');
    });

    $('body').on('click', '.inventory-table table tr', function(e){
        const action = $(this).data('action');
        const productId = $(this).data('product-id');
        //check we are not clicking on a link or input inside the row
        if ($(e.target).is('a, input, button, .no-row-action') || $(e.target).closest('a, input, button, .no-row-action').length) {
            return;
        }
        if (action) {
            window.location.href = '#' + action + (productId ? '[' + productId + ']' : '');
        }
    });

    $('body').on('click', '.modal .close-modal-button, .modal', function(e){
        //remove hash from URL without reloading
        history.replaceState("", document.title, window.location.pathname + window.location.search);
        e.stopPropagation();
        e.preventDefault();
        //if we are not clicking directly on the overlay (i.e. we are clicking inside the modal content), do not close
        if (!$(e.target).hasClass('modal') && !$(e.target).hasClass('close-modal-button')) {
            return;
        }
        $('.modal').removeClass('active');
        endCameraUpload();
        $('#upload-visual-modal').removeClass('active');
    });

    //bind escape key to close modal
    $(document).on('keydown', function(e) {
        if (e.key === "Escape") {
            if ($('.modal').hasClass('active')) {
                $('.modal').removeClass('active');
                //remove hash from URL without reloading
                history.replaceState("", document.title, window.location.pathname + window.location.search);
                endCameraUpload();
                $('#upload-visual-modal').removeClass('active');
            }
        }
    });

    var currentHash = window.location.hash;

    //when the window receives a hash change, check for modal open
    $(window).on('hashchange', function(e) {
        currentHash = window.location.hash.substring(1);
        const hash = window.location.hash.substring(1); // Remove the '#' character
        if (!hash) {
            // console.log('No hash, closing modals and resetting variation forms.');
            // $('.modal-product-overlay').removeClass('active');
            // stopVariationMerge();
            // //remove the active class from the variation table row
            // $('.variation-table tr').removeClass('active');
            // $('.update-variation-form').addClass('becoming-active').removeClass('active').delay(300).queue(function(next){
            //     $(this).removeClass('becoming-active');
            //     next();
            // });
        }
        if (hash.includes('report-damage-modal')) {
            $('#report-damage-modal').addClass('active');
        }
        if (hash.includes('open-modal-product')) {
            launchProductModal();
        }
        if (hash.includes('edit-variation')) {
            var variationId = null;
            $('.update-variation-form').addClass('becoming-active').delay(10).queue(function(next){
                $(this).removeClass('becoming-active').addClass('active');
                //slide to the element
                $('html, body').animate({
                    scrollTop: $(this).offset().top - 100
                }, 500);
                next();
            });
            //get the variation ID from the hash if needed between []
            const variationIdMatch = hash.match(/edit-variation\[(\d+)\]/);
            if (variationIdMatch) {
                variationId = variationIdMatch[1];
                console.log('Open edit for variation ID: ' + variationId);
                //load variation details via AJAX if needed
                loadVariationDetails(variationId); //load variation details via AJAX if needed
            }
        } else {
            if ($('.update-variation-form').hasClass('active')) {
                $('.variation-table tr').removeClass('active');
                //remove the active class from the variation table row
                $('.update-variation-form').addClass('becoming-active').removeClass('active').delay(300).queue(function(next){
                    $(this).removeClass('becoming-active');
                    next();
                });
            }
        }
        if (hash.includes('add-variation')) {
            $('.new-variation-form').addClass('becoming-active').delay(10).queue(function(next){
                $(this).removeClass('becoming-active').addClass('active');
                //slide to the element
                $('html, body').animate({
                    scrollTop: $(this).offset().top - 100
                }, 500);
                next();
            });
            const variationIdMatch = hash.match(/add-variation\[(\d+)\]/);
            if (variationIdMatch) {
                const variationId = variationIdMatch[1];
                createNewVariation(variationId);
            } else {
                createNewVariation();
            }
        } else {
            if ($('.new-variation-form').hasClass('active')) {
                $('.new-variation-form').addClass('becoming-active').removeClass('active').delay(300).queue(function(next){
                    $(this).removeClass('becoming-active');
                    next();
                });
            }
        }

        if (hash.includes('upload-visual')) {
            console.log('Open upload visual modal');
            beginCameraUpload();
        }

        if (hash.includes('merge-variation')) {
            launchVariationMerge();
        } else {
            if ($('.modal-variation-merge-overlay').hasClass('active')) {
                stopVariationMerge();
            }
        }
    });
    //check on page load too
    const initialHash = window.location.hash.substring(1);
    if (initialHash.includes('report-damage-modal')) {
        $('#report-damage-modal').addClass('active');
    }
    if (initialHash.includes('open-modal-product')) {
        $('.modal-product-overlay').addClass('active');
        const productIdMatch = initialHash.match(/open-modal-product\[(\d+)\]/);
        if (productIdMatch) {
            const productId = productIdMatch[1];
            console.log('Open modal for product ID: ' + productId);
            //load product details via AJAX if needed
            launchProductModal();
        }
    }

    if (initialHash.includes('edit-variation')) {
        $('.update-variation-form').addClass('becoming-active').delay(10).queue(function(next){
            $(this).removeClass('becoming-active').addClass('active');
            //slide to the element
            $('html, body').animate({
                scrollTop: $(this).offset().top - 100
            }, 500);
            next();
        });
        const variationIdMatch = initialHash.match(/edit-variation\[(\d+)\]/);
        if (variationIdMatch) {
            const variationId = variationIdMatch[1];
            console.log('Open edit for variation ID: ' + variationId);
            //load variation details via AJAX if needed
            loadVariationDetails(variationId);
        }
    }

    if (initialHash.includes('add-variation')) {
        $('.new-variation-form').addClass('becoming-active').delay(10).queue(function(next){
            $(this).removeClass('becoming-active').addClass('active');
            //slide to the element
            $('html, body').animate({
                scrollTop: $(this).offset().top - 100
            }, 500);
            next();
        });
        const variationIdMatch = initialHash.match(/add-variation\[(\d+)\]/);
        if (variationIdMatch) {
            const variationId = variationIdMatch[1];
            createNewVariation(variationId);
        } else {
            createNewVariation();
        }
    }

    if (initialHash.includes('upload-visual')) {
        console.log('Open upload visual modal');
        beginCameraUpload();
    }

    if (initialHash.includes('merge-variation')) {
        launchVariationMerge();
    } else {
        stopVariationMerge();
    }

    //get buttons with href and convert to links
    $('body').on('click', 'button[href]', function(e){
        const href = $(this).attr('href');
        if (href) {
            window.location.href = href;
            e.preventDefault();
        }
    });

    $('body').on('click', '.new-variation-form .discard-new-variation', function(e){
        e.preventDefault();
        $('.new-variation-form').addClass('becoming-active').removeClass('active').delay(300).queue(function(next){
            $(this).removeClass('becoming-active');
            next();
        });
        //remove hash from URL without reloading
        history.replaceState("", document.title, window.location.pathname + window.location.search);
    });

    $('body').on('click', '.new-variation-form .save-new-variation', function(e){
        var product_id = $('#new-variation-product-id').val();
        var form_inputs = $(this).parents('.actions').siblings('.input-row-group').find('input, select, textarea').serialize();

        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: form_inputs + '&action=jask_inventory_save_new_variation&security=' + jaskInventory.nonce + '&product_id=' + product_id,
            success: function(response){
                if(response.success){
                    console.log(response);
                    console.log('Variation created successfully.');
                    // Optionally, you can add the new variation to the variation table on the page without reloading
                    //append the new tr to the variation table
                    if (response.data.update === false) {
                        if (response.data.added.length > 0) {
                            console.log('Adding new variations to the table. Added variations: ', response.data.added);
                            //loop through each added item and add to the table
                            for (var i = 0; i < response.data.added.length; i++) {
                                console.log('Processing added variation: ', response.data.added[i]);
                                var addedItem = response.data.added[i];
                                //see if there is already a variation within the table that matches the variation_id
                                if ($('.variation-table tbody tr[data-variation-id="' + addedItem.variation_id + '"]').length) {
                                    //replace the existing row with the new row html
                                    $('.variation-table tbody tr[data-variation-id="' + addedItem.variation_id + '"]').replaceWith(addedItem.row_html);
                                } else {
                                    $('.variation-table tbody').append(addedItem.row_html);
                                }
                            }
                            Array.from(productStatusElements).forEach(function(element) {
                                updateProductStatus(element);
                            });
                            Array.from(productHistoryLogElements).forEach(function(element) {
                                updateHistoryLog(element);
                            });
                            //trigger hash change to open the edit variation form for the new variation
                            window.location.hash = 'edit-variation[' + response.data.variation_id + ']';
                            history.replaceState("", document.title, window.location.pathname + window.location.search);
                        } else {
                            console.log('No variations were added. Response data: ', response.data);
                        }
                    } else {
                        console.log('Variation was updated instead of added. Updated variation ID: ' + response.data.variation_id);
                    }
                } else {

                    $.each (response.data.errors, function(field, field_data){
                        console.log('Error with field ' + field + ': ' + field_data.message);
                        if (field_data.message.includes('Please select a value for ') || field_data.message.includes(' cannot be empty')) {
                            $('[name="' + field_data.field + '"]').each(function(){
                                if ($(this).val() === '' || $(this).val() === '-1') {
                                    $(this).addClass('error');
                                    $(this).attr('title', field_data.message);
                                } else {
                                    $(this).removeClass('error');
                                    $(this).removeAttr('title');
                                }
                            });
                        } else if(field_data.message.includes('must be a non-negative number')) {
                            $('[name="' + field_data.field + '"]').each(function(){
                                if ($(this).val() <= 0) {
                                    $(this).addClass('error');
                                    $(this).attr('title', field_data.message);
                                } else {
                                    $(this).removeClass('error');
                                    $(this).removeAttr('title');
                                }
                            });
                        } else {
                            $('[name="' + field_data.field + '"]').addClass('error');
                        }
                    });

                    if (response.data && response.data.field && response.data.message) {
                        //highlight the field with an error
                        if (response.data.message.includes('Please select a value for ')) {
                            $('[name="' + response.data.field + '"]').each(function(){
                                if ($(this).val() === '' || $(this).val() === '-1') {
                                    $(this).addClass('error');
                                } else {
                                    $(this).removeClass('error');
                                }
                            });
                        } else {
                            $('[name="' + response.data.field + '"]').addClass('error');
                        }
                        return;
                    } else {
                        console.log('Error creating variation: ' + response.data);
                    }
                }
            },
            error: function(){
                console.log('An unexpected error occurred while creating variation.');
            }
        });
        //prevent page reload and hash change
        //remove hash from URL without reloading
        e.stopPropagation();
        e.preventDefault();
    });

    $('body').on('click', '.update-variation-form .discard-update-variation', function(e){
        e.preventDefault();
        //remove the active class from the variation table row
        $('.variation-table tr').removeClass('active');
        $('.update-variation-form').addClass('becoming-active').removeClass('active').delay(300).queue(function(next){
            $(this).removeClass('becoming-active');
            next();
        });
        //remove hash from URL without reloading
        history.replaceState("", document.title, window.location.pathname + window.location.search);
    });

    $('body').on('click', '.update-variation-form .save-update-variation', function(e){
        //loop through all 'variation-select' selects and get the selected value and add to the form data
        var form_inputs = $(this).parents('.actions').siblings('.form-inputs').find('input, select, textarea').serialize();
        var variation_id = $('#update-variation-id').val();
        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: form_inputs + '&action=jask_inventory_update_variation&security=' + jaskInventory.nonce + '&variation_id=' + variation_id,
            success: function(response){
                if(response.success){
                    console.log('Variation updated successfully.');
                    //update the variation row in the variation table on the page without reloading
                    if (response.data.row_html) {
                        //replace the existing row with the new row html
                        $('.variation-table tbody tr[data-variation-id="' + variation_id + '"]').replaceWith(response.data.row_html);
                    }
                    // Optionally, you can update the variation details on the page without reloading
                    // For example, update the variation table row with the new details
                    // Then close the edit form
                    $('.update-variation-form .discard-update-variation').trigger('click');
                    Array.from(productStatusElements).forEach(function(element) {
                        updateProductStatus(element);
                    });
                    Array.from(productHistoryLogElements).forEach(function(element) {
                        updateHistoryLog(element);
                    });
                } else {
                    if (response && response.data && response.data.error === 'merge_variations') {
                        var merge_variation_id = response.data.variation_id;
                        console.log('Variation merge required. Redirecting to edit variation ID: ' + merge_variation_id);
                        //push new hash to trigger the edit variation form for the merged variation
                        window.location.hash = 'merge-variation[' + variation_id + '::' + merge_variation_id + ']';
                    } else {
                        console.log('Error updating variation: ' + response.data);
                    }
                }
            },
            error: function(){
                console.log('An unexpected error occurred while updating variation.');
            }
        });

        e.preventDefault();
        e.stopPropagation();
        return;
    });

    $('body').on('click', '.variation-table .delete-variation-button', function(e){

        var variationId = $(this).closest('tr').data('variation-id');
        console.log('Attempting to delete variation ID: ' + variationId);

        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: {
                action: 'jask_inventory_delete_variation_modal',
                security: jaskInventory.nonce,
                variation_id: variationId
            },
            success: function(response){
                if(response.success){
                    console.log('Delete confirmation loaded successfully.');
                    //remove any existing delete confirmation modals
                    $('.modal-variation-delete-overlay').remove();
                    $('#page').append(response.data.html);
                    window.setTimeout(function(){
                        $('.modal-variation-delete-overlay').addClass('active');
                    }, 10);
                } else {
                    console.log('Error loading delete confirmation: ' + response.data);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while loading delete confirmation.');
            }
        });

        e.preventDefault();
    });

    $('body').on('change', '.variation-select', function(e){

        if ($(this).find('option:selected').val() === 'create_new' && $(this).find('option:selected').data('hierarchical') == false) {
            console.log('Create new option selected for attribute: ' + $(this).attr('name'));
            //show the hidden input for creating new attribute value
            $(this).parents('li').find('.new-attribute-value').show();
            //hide the select for this attribute
            $(this).parent().addClass('hidden');
        }

    });

    $('body').on('click', '.cancel-new-value', function(e){
        e.preventDefault();
        var attribute = $(this).data('attribute');
        //hide the new attribute value input
        $(this).parents('li').find('.new-attribute-value').hide();
        //show the select for this attribute
        $(this).parents('li').find('.variation-select').parent().removeClass('hidden');
        //reset the value of the select to the first option
        $(this).parents('li').find('.variation-select').val($(this).parents('li').find('.variation-select option').first().val());
    });

    $('body').on('click', '#cancel-merge-variations-button', function(e){
        //remove hash from URL without reloading
        stopVariationMerge();
        //step back in history to remove the merge-variation hash
        history.replaceState("", document.title, window.location.pathname + window.location.search);
        e.preventDefault();
    });

    $('body').on('click', '.cancel-delete-variation', function(e){
        //remove the delete confirmation modal
        $('.modal-variation-delete-overlay').removeClass("active").delay(300).queue(function(next){
            $(this).remove();
            next();
        });
        e.preventDefault();
    });

    $('body').on('click', '.confirm-delete-variation', function(e){
        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: {
                action: 'jask_inventory_delete_variation',
                security: jaskInventory.nonce,
                variation_id: $(this).data('variation-id')
            },
            success: function(response){
                if(response.success){
                    console.log('Variation deleted successfully.');
                    //remove the variation row from the table
                    $('.variation-table tbody tr[data-variation-id="' + response.data.variation_id + '"]').remove();
                    //remove the delete confirmation modal
                    $('.modal-variation-delete-overlay').removeClass("active").delay(300).queue(function(next){
                        $(this).remove();
                        next();
                    });
                    Array.from(productStatusElements).forEach(function(element) {
                        updateProductStatus(element);
                    });
                    Array.from(productHistoryLogElements).forEach(function(element) {
                        updateHistoryLog(element);
                    });
                } else {
                    console.log('Error deleting variation: ' + response.data);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while deleting variation.');
            }
        });
        e.preventDefault();
    });

    $('body').on('click', '#merge-variations-button', function(e){
        //merge variations logic here
        e.preventDefault();
        var formInputs = $('.merge-wrapper').find('input, select, textarea').serialize();
        console.log('Merging variations with data: ' + formInputs);
        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: formInputs + '&action=jask_inventory_merge_variations&security=' + jaskInventory.nonce,
            success: function(response){
                if(response.success){
                    if (response.data.table_update) {
                        for (var variationId in response.data.table_update) {
                            var updateData = response.data.table_update[variationId];
                            if (updateData.action === 'remove') {
                                //remove the variation row from the table
                                $('.variation-table tbody tr[data-variation-id="' + variationId + '"]').remove();
                            } else if (updateData.action === 'update') {
                                //update the existing row with the new html
                                $('.variation-table tbody tr[data-variation-id="' + variationId + '"]').replaceWith(updateData.html);
                            }
                        }
                    }
                    console.log('Variations merged successfully.');
                    //close the merge modal
                    $('#cancel-merge-variations-button').trigger('click');
                } else {
                    console.log('Error merging variations: ' + response.data);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while merging variations.');
            }
        });
    });

    $('body').on('click', '#switch-camera-button', function(e){
        e.preventDefault();
        //switch camera logic here
        switchCamera();
    });

    $('body').on('click', '#capture-photo-button', function(e){
        e.preventDefault();
        //capture photo using the device camera and display in the modal
        capturePhoto();
    });

    $('body').on('click', '#upload-photo-button', function(e){
        e.preventDefault();
        //trigger file input click
        handleFileUploadClick();
    });

    $('body').on('click', '#retake-photo-button', function(e){
        $('#upload-visual-modal .camera-controls').removeClass('captured');
        $('#capture-canvas').hide();
        $('#camera-stream').show().css('opacity', '1');
        //restart the camera stream if needed
        restartCameraStream();
        e.preventDefault();
    });

    $('body').on('click', '#confirm-photo-button', function(e){

        //end the camera stream
        endCameraUpload();

        //create a FormData object and append the file
        var formData = new FormData();
        formData.append('file', $('#photo-file-input')[0].files[0]);
        formData.append('action', $('#photo-upload-form input[name="action"]').val());
        formData.append('item_id', $('#photo-upload-form input[name="item_id"]').val());
        formData.append('security', jaskInventory.nonce);

        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(response){
                if(response.success){
                    console.log('Photo uploaded successfully.');
                    refreshProductVisuals();
                    //close the modal
                    $('#upload-visual-modal').removeClass('active');
                    history.replaceState("", document.title, window.location.pathname + window.location.search);
                    Array.from(productHistoryLogElements).forEach(function(element) {
                        updateHistoryLog(element);
                    });
                } else {
                    console.log('Error uploading photo: ' + response.data);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while uploading photo.');
            }
        });
        e.preventDefault();
    });

    $('body').on('click', '.remove-visual-item-button', function(e){
        e.preventDefault();
        var attachmentId = $(this).data('attachment-id');
        var itemId = $('.edit-item-form').data('item-id');
        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: {
                action: 'jask_inventory_remove_visual_item',
                security: jaskInventory.nonce,
                attachment_id: attachmentId,
                item_id: itemId
            },
            success: function(response){
                if(response.success){
                    console.log('Visual item removed successfully.');
                    refreshProductVisuals();
                    Array.from(productHistoryLogElements).forEach(function(element) {
                        updateHistoryLog(element);
                    });
                } else {
                    console.log('Error removing visual item: ' + response.data);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while removing visual item.');
            }
        });
    });

    $('body').on('keyup', '#item-name', function(e){
        $('.inventory-item-name').text($(this).val());
    });

    $('body').on('click', '.mobile-menu-toggle', function(e){
        $('.mobile-navigation-wrapper').toggleClass('active');
    });

    $('body').on('click', '#save-draft-inventory-item-button', function(e){
        var form = $('#inventory-item-form');
        var serializedData = form.serialize();
        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: {
                action: 'jask_inventory_save_item',
                security: jaskInventory.nonce,
                formData: serializedData,
                save_as_draft: 1
            },
            success: function(response){
                if(response.success){
                    Array.from(productStatusElements).forEach(function(element) {
                        updateProductStatus(element);
                    });
                    Array.from(productHistoryLogElements).forEach(function(element) {
                        updateHistoryLog(element);
                    });
                    //remove the dirty state from the form
                    $('#inventory-item-form').removeClass('dirty');
                    //remove the unsaved changes warning on page exit
                    window.onbeforeunload = null;
                    //remove unsaved class from track-unsaved elements
                    $('.track-unsaved').removeClass('unsaved');
                    console.log('Draft saved successfully.');
                    // Optionally, you can display a success message or update the UI to reflect the saved draft
                } else {
                    console.log('Error saving draft: ' + response.data);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while saving draft.');
            }
        });
        e.preventDefault();
        return;
    });

    $('body').on('click', '#publish-inventory-item-button', function(e){
        var form = $('#inventory-item-form');
        var serializedData = form.serialize();
        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: {
                action: 'jask_inventory_save_item',
                security: jaskInventory.nonce,
                formData: serializedData,
                save_as_draft: 0
            },
            success: function(response){
                if(response.success){
                    Array.from(productStatusElements).forEach(function(element) {
                        updateProductStatus(element);
                    });
                    Array.from(productHistoryLogElements).forEach(function(element) {
                        updateHistoryLog(element);
                    });
                    Array.from(productActionsElements).forEach(function(element) {
                        updateProductActions(element);
                    });
                    //remove the dirty state from the form
                    $('#inventory-item-form').removeClass('dirty');
                    //remove the unsaved changes warning on page exit
                    window.onbeforeunload = null;
                    //remove unsaved class from track-unsaved elements
                    $('.track-unsaved').removeClass('unsaved');
                    console.log('Item published successfully.');
                    // Optionally, you can redirect to the item page or update the UI to reflect the published item
                } else {
                    console.log('Error publishing item: ' + response.data);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while publishing item.');
            }
        });
        e.preventDefault();
        return;
    });

    $('body').on('click', '#save-changes-inventory-item-button', function(e){
        var form = $('#inventory-item-form');
        var serializedData = form.serialize();
        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: {
                action: 'jask_inventory_save_item',
                security: jaskInventory.nonce,
                formData: serializedData,
                save_as_draft: 0
            },
            success: function(response){
                if(response.success){
                    Array.from(productHistoryLogElements).forEach(function(element) {
                        updateHistoryLog(element);
                    });
                    Array.from(productActionsElements).forEach(function(element) {
                        updateProductActions(element);
                    });
                    //remove the dirty state from the form
                    $('#inventory-item-form').removeClass('dirty');
                    //remove the unsaved changes warning on page exit
                    window.onbeforeunload = null;
                    //remove unsaved class from track-unsaved elements
                    $('.track-unsaved').removeClass('unsaved');
                    console.log('Changes saved successfully.');
                    // Optionally, you can display a success message or update the UI to reflect the saved changes
                } else {
                    console.log('Error saving changes: ' + response.data);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while saving changes.');
            }
        });
        e.preventDefault();
        return;
    });

    $('body').on('click', '#unpublish-inventory-item-button', function(e){
        var form = $('#inventory-item-form');
        var serializedData = form.serialize();
        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: {
                action: 'jask_inventory_save_item',
                security: jaskInventory.nonce,
                formData: serializedData,
                save_as_draft: 1
            },
            success: function(response){
                if(response.success){
                    Array.from(productStatusElements).forEach(function(element) {
                        updateProductStatus(element);
                    });
                    Array.from(productHistoryLogElements).forEach(function(element) {
                        updateHistoryLog(element);
                    });
                    Array.from(productActionsElements).forEach(function(element) {
                        updateProductActions(element);
                    });
                    //remove the dirty state from the form
                    $('#inventory-item-form').removeClass('dirty');
                    //remove the unsaved changes warning on page exit
                    window.onbeforeunload = null;
                    //remove unsaved class from track-unsaved elements
                    $('.track-unsaved').removeClass('unsaved');
                    console.log('Item unpublished successfully.');
                    // Optionally, you can redirect to the item page or update the UI to reflect the unpublished item
                } else {
                    console.log('Error unpublishing item: ' + response.data);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while unpublishing item.');
            }
        });
        e.preventDefault();
        return;
    });

    $('body').on('click', '.delete-inventory-item-button', function(e){
        var itemId = $(this).data('item-id');
        console.log('Attempting to delete item ID: ' + itemId);

        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: {
                action: 'jask_inventory_delete_item_modal',
                security: jaskInventory.nonce,
                item_id: itemId
            },
            success: function(response){
                if(response.success){
                    console.log('Delete confirmation loaded successfully.');
                    //remove any existing delete confirmation modals
                    $('.modal-item-delete-overlay').remove();
                    $('#page').append(response.data.html);
                    window.setTimeout(function(){
                        $('.modal-item-delete-overlay').addClass('active');
                    }, 10);
                } else {
                    console.log('Error loading delete confirmation: ' + response.data);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while loading delete confirmation.');
            }
        });

        e.preventDefault();
    });

    $('body').on('click', '.confirm-delete-wardrobe-item', function(e){
        var itemId = $(this).data('item-id');
        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: {
                action: 'jask_inventory_delete_item',
                security: jaskInventory.nonce,
                item_id: itemId
            },
            success: function(response){
                if(response.success){
                    console.log('Item deleted successfully.');
                    //redirect to the inventory list page after deletion
                    window.location.href = jaskInventory.inventoryListUrl;
                } else {
                    console.log('Error deleting item: ' + response.data);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while deleting item.');
            }
        });
        e.preventDefault();
    });

    $('body').on('click', '.new-option-actions .save-new-option-button', function(e){
        var selectElement = $(this).parents('.new-option-actions').siblings('select');
        var newOptionValue = $(this).parents('.new-option-actions').siblings('.new-option-input').val();
        var optionParent = $(this).parents('.new-option-actions').siblings('.new-option-input').data('parent');
        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: {
                action: 'jask_inventory_create_new_attribute_option',
                security: jaskInventory.nonce,
                attribute_name: selectElement.attr('name'),
                option_value: newOptionValue,
                option_parent: optionParent
            },
            success: function(response){
                if(response.success){
                    if (response.data.html) {
                        var hasSelect2 = false;
                        if (selectElement.hasClass('select2-hidden-accessible')) {
                            hasSelect2 = true;
                        }
                        if (hasSelect2) {
                            selectElement.select2('destroy');
                        }
                        //take the response.data.html and replace the existing select element with the new html which includes the new option
                        newElement = selectElement.parents('li');
                        newElement.html(response.data.html);
                        //if there is a select2 element, trigger change to update the select2 options and refresh the select2 element
                        if (hasSelect2) {
                            newElement.find('select').select2();
                        }
                        console.log('New option created successfully.');
                    } else {
                        //find the select element for this option and reset it to the first option
                        selectElement.val(selectElement.find('option').first().val());
                        if (selectElement.hasClass('select2-hidden-accessible')) {
                            selectElement.find('option[class="new-option"]').prop('selected', false);
                            selectElement.trigger('change');
                        }
                        console.log('Error: No HTML returned for new option.');
                    }
                } else {
                    console.log('Error creating new option: ' + response.data);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while creating new option.');
            }
        });
        e.preventDefault();
    });

    $('body').on('click', '.new-option-actions .cancel-new-option-button', function(e){
        //find the select element for this option and reset it to the first option
        $(this).parents('.new-option-actions').siblings('select').val($(this).parents('.new-option-actions').siblings('select').find('option').first().val());
        //if there is a select2 element, unselect the "new-option" option and trigger change
        if ($(this).parents('.new-option-actions').siblings('select').hasClass('select2-hidden-accessible')) {
            $(this).parents('.new-option-actions').siblings('select').find('option[class="new-option"]').prop('selected', false);
            $(this).parents('.new-option-actions').siblings('select').trigger('change');
        }
        e.preventDefault();
    });

    $('body').on('change', '.wardrobe-variation-attribute', function(e){
        console.log('Variation attribute changed, updating variation details.');
        if ($(this).find('option[class="new-option"]').is(':selected')) {
            console.log('New option selected, showing input field.');
            var parent = $(this).find('option[class="new-option"]:selected').data('parent');
            if (parent) {
                $(this).parents('li').find('.new-option-input').data('parent', parent);
            } else {
                $(this).parents('li').find('.new-option-input').data('parent', 0);
            }
        }
    });

    $('body').on('click', '.undo-log-entry-button', function(e){
        var logEntryId = $(this).data('entry-id');
        var undoAction = $(this).data('undo-action');

        console.log('Attempting to undo log entry ID: ' + logEntryId + ' with action: ' + undoAction);
        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: {
                action: 'jask_inventory_undo_log_entry',
                security: jaskInventory.nonce,
                log_entry_id: logEntryId,
                undo_action: undoAction
            },
            success: function(response){
                if(response.success){
                    console.log('Log entry undone successfully.');
                    Array.from(productVariationsElements).forEach(function(element) {
                        updateVariationTable(element);
                    });
                    Array.from(productStatusElements).forEach(function(element) {
                        updateProductStatus(element);
                    });
                    Array.from(productHistoryLogElements).forEach(function(element) {
                        updateHistoryLog(element);
                    });
                    refreshProductVisuals();
                } else {
                    console.log('Error undoing log entry: ' + response.data);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while undoing log entry.');
            }
        });
        e.preventDefault();
    });

    $('body').on('click', '.delete-log-entry-button', function(e){
        var logEntryId = $(this).data('entry-id');
        
        console.log('Attempting to delete log entry ID: ' + logEntryId);
        $.ajax({
            url: jaskInventory.ajaxUrl,
            method: 'POST',
            data: {
                action: 'jask_inventory_delete_log_entry',
                security: jaskInventory.nonce,
                log_entry_id: logEntryId
            },
            success: function(response){
                if(response.success){
                    console.log('Log entry deleted successfully.');
                    Array.from(productHistoryLogElements).forEach(function(element) {
                        updateHistoryLog(element);
                    });
                } else {
                    console.log('Error deleting log entry: ' + response.data);
                }
            },
            error: function(){
                console.log('An unexpected error occurred while deleting log entry.');
            }
        });
        e.preventDefault();
    });

    $('body').on('change', '.product-attribute-select-input', function(e){
        //reset all options in other selects to enabled
        $('.product-attribute-select-input').not(this).find('option').each(function(){
            $(this).prop('disabled', false);
        });
        var selectedOption = $(this).find('option:selected');
        var variationIds = selectedOption.data('variation-ids');
        //force variationIds to always be a string rather than an int, which can happen if there is only one variation id associated with this option

        if (variationIds) {
            variationIds = variationIds.toString();
        }

        if (variationIds && variationIds.length > 0) {
            //check if variationIds contains a comma, if so split into an array, if not make it an array with one element
            if (variationIds.indexOf(',') > -1) {
                variationIds = variationIds.split(',');
            } else {
                variationIds = [variationIds];
            }
            //loop through other .product-attribute-select-input selects and disable options that don't have a variation in common with the selected option
            $('.product-attribute-select-input').not(this).each(function(){
                $(this).find('option').each(function(){
                    var optionVariationIds = $(this).data('variation-ids');
                    if (optionVariationIds) {
                        optionVariationIds = optionVariationIds.toString();
                    }
                    if (optionVariationIds && optionVariationIds.length > 0) {
                        if (optionVariationIds.indexOf(',') > -1) {
                            optionVariationIds = optionVariationIds.split(',');
                        } else {
                            optionVariationIds = [optionVariationIds];
                        }
                        //check if there is any variation id in common between variationIds and optionVariationIds, if not disable this option
                        var hasCommonVariation = variationIds.some(function(variationId) {
                            return optionVariationIds.includes(variationId);
                        });
                        if (!hasCommonVariation) {
                            $(this).prop('disabled', true);
                        }
                    }
                });
            });
        } else {
            //if no variation ids are associated with the selected option, enable all options in the other selects
            $('.product-attribute-select-input').not(this).each(function(){
                $(this).find('option').each(function(){
                    $(this).prop('disabled', false);
                });
            });
        }
        //if all selects have a selected option that is not the default option, trigger a click on the corresponding variation row in the variation table to show the details for this variation
        var allSelected = true;
        var selectedVariationIds = [];
        $('.product-attribute-select-input').each(function(){
            var selectedOption = $(this).find('option:selected');
            if (selectedOption.val() === '' || selectedOption.val() === '-1') {
                allSelected = false;
                return false;
            } else {
                var variationIds = selectedOption.data('variation-ids');
                if (variationIds) {
                    variationIds = variationIds.toString();
                    if (variationIds.indexOf(',') > -1) {
                        variationIds = variationIds.split(',');
                    } else {
                        variationIds = [variationIds];
                    }
                    selectedVariationIds.push(variationIds);
                }
            }
        });
        if (allSelected && selectedVariationIds.length > 0) {
            //find the variation id that is common between all selected options
            var commonVariationId = selectedVariationIds.reduce(function(commonId, variationIds) {
                return commonId.filter(function(id) {
                    return variationIds.includes(id);
                });
            });
        }
        if (allSelected && commonVariationId && commonVariationId.length > 0) {
            $('#modal-selected-variation-id').val(commonVariationId[0]);
            $('#modal-edit-item-button').find('span:not(.icon)').text('Edit Variation #' + commonVariationId[0]);
        } else {
            $('#modal-selected-variation-id').val('');
            $('#modal-edit-item-button').find('span:not(.icon)').text('Edit Item');
        }
    });

    $('body').on('click', '#reset-attributes-button', function(e){
        $('.product-attribute-select-input').each(function(){
            $(this).val($(this).find('option').first().val());
            $(this).trigger('change');
        });
        e.preventDefault();
    });

    $('body').on('click', '#modal-edit-item-button', function(e){
        e.preventDefault();
        if ($('#modal-selected-variation-id').val()) {
            var variationId = $('#modal-selected-variation-id').val();
            window.location.href = $(this).attr('href') + '/#edit-variation[' + variationId + ']';
        }
    });

    $('body').on('click', '#filter-toggle-button', function(e){
        $('.search-filter-wrapper').toggleClass('filters-active');
        e.preventDefault();
    });

    $('body').on('click', '.add-another-variation', function(e){
        e.preventDefault();
        var input_row = $(this).parents('.input-row');
        var new_row = input_row.clone(true);
        //set each input to the same value as the input_row except for the variation-sku input, which should be incremented by 1

        $.each(new_row.find('input, select, textarea'), function(){
            var name = $(this).attr('name');
            if (name) {
                var baseName = name.replace('[]', '');
                input_row.find('input[name="' + baseName + '[]"], select[name="' + baseName + '[]"], textarea[name="' + baseName + '[]"]').each(function(index){
                    new_row.find('input[name="' + baseName + '[]"], select[name="' + baseName + '[]"], textarea[name="' + baseName + '[]"]').eq(index).val($(this).val());
                });
            }
        });

        item_ref = new_row.find('input[name^="variation-sku"]').val();
        new_item_ref = parseInt(item_ref) + 1;
        //pad the new_item_ref with leading zeros to match the length of the original item_ref
        new_item_ref = new_item_ref.toString().padStart(item_ref.length, '0');
        new_row.find('input[name^="variation-sku"]').val(new_item_ref);
        new_row.insertAfter(input_row);
    });

    $('body').on('click', '.remove-new-variation', function(e){
        e.preventDefault();
        var input_row = $(this).parents('.input-row');
        input_row.remove();
    });

    $('body').on('change', 'ul.form-inputs input, ul.form-inputs select, ul.form-inputs textarea', function(e){
        //check the name against any list item that has a matching data-visible-input attribute, if there is a match, toggle the visibility of this list item based on whether the input that was changed has the data-visible-value that matches this input
        var inputName = $(this).attr('name');
        var inputValue = $(this).val();
        $('ul.form-inputs li[data-visible-input="' + inputName + '"]').each(function(){
            var visibleValue = $(this).data('visible-value');
            if (visibleValue == inputValue) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        });
    });

    var lastTouch = null
    var lastMouseMove = null;

    window.addEventListener('touchstart', function (event) {
        lastTouch = event.touches[0]
    })

    //bind mousedown and move events to add 'scrolling' class to the gallery image wrapper, and remove when scrolling stops
    window.addEventListener('mousedown', function (event) {
        lastMouseMove = event;
    })

    window.addEventListener('touchend', function (event) {
        lastTouch = null
    })

    window.addEventListener('mouseup', function (event) {
        lastMouseMove = null;
    })

    window.addEventListener('touchmove', function (event) {
        var currentTouch = event.changedTouches[0]
    
        if (lastTouch) {
            var scrollDistanceX = currentTouch.clientX - lastTouch.clientX;
            var scrollDistanceY = currentTouch.clientY - lastTouch.clientY;
            if (Math.abs(scrollDistanceX) > 10 || Math.abs(scrollDistanceY) > 10) {
                //if scrollDistanceX is greater than 0, we are scrolling right, if less than 0 we are scrolling left
                if (scrollDistanceX > 0) {
                    //scrolling right
                    $('.gallery-image-wrapper').removeClass('scrolling-left').addClass('scrolling-right');
                } else {
                    //scrolling left
                    $('.gallery-image-wrapper').removeClass('scrolling-right').addClass('scrolling-left');
                }
            }
        }
    
        lastTouch = currentTouch;
    });

    window.addEventListener('mousemove', function (event) {
        if (lastMouseMove && event.buttons === 1) { // Check if the left mouse button is pressed
            var scrollDistanceX = event.clientX - lastMouseMove.clientX;
            var scrollDistanceY = event.clientY - lastMouseMove.clientY;
            if (Math.abs(scrollDistanceX) > 10 || Math.abs(scrollDistanceY) > 10) {
                //if scrollDistanceX is greater than 0, we are scrolling right, if less than 0 we are scrolling left
                if (scrollDistanceX > 0) {
                    //scrolling right
                    $('.gallery-image-wrapper').removeClass('scrolling-left').addClass('scrolling-right');
                } else {
                    //scrolling left
                    $('.gallery-image-wrapper').removeClass('scrolling-right').addClass('scrolling-left');
                }
            }
        }
    });

});
